import React, { Component } from 'react';
import { CURSORS_LIST } from '~/constants/cursorsList';
import SelectList from '@/SelectList';
import CursorsList from '@/SelectList/CursorsList';
import { observer, inject } from 'mobx-react';

@inject("featuresListStore") @observer 
export class CursorStyle extends Component {
  constructor(props = { featureId }){
    super(props);
    this.state = {
      className: '',
      cursors: CURSORS_LIST
    }
  }
  resetCursorStyle(){
    if (this.state.className) {
      document.body.classList.remove(this.state.className);
      this.setState({className: ''});
    }
  }
  changeCursorStyle(cursorClassName){
    this.resetCursorStyle();
    document.body.classList.add(cursorClassName);
    this.setState({className: cursorClassName});
  }
  render() {
    let { cursors } = this.state;
    let { featureId } = this.props;
    let { getFeatureById, setFeatureOptions } = this.props.featuresListStore;
    let feature = getFeatureById(featureId);

    let selectListProps = {
      list: cursors,
      selectedId: feature.options.selectedId,
      LayoutComponent: CursorsList,
      onReset: () => {
        this.resetCursorStyle();
        setFeatureOptions(featureId, {
          selectedId: null
        });
      },
      onChoise: (cursor) => {
        this.changeCursorStyle(cursor.className);
        setFeatureOptions(featureId, {
          selectedId: cursor.id
        });
      }
    }
    return (
      <SelectList { ...selectListProps} />
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Feature/FeatureActions/CursorStyle/index.js